// Кодирование данных бани в строку для URL hash
export function encodeBanyaData(banya) {
  if (!banya) return '';
  const data = {
    n: banya.name,
    d: banya.date,
    st: banya.startTime,
    et: banya.endTime,
    hr: banya.hourlyRate,
    bc: banya.broomCost,
    p: banya.people.map((p) => ({
      id: p.id,
      name: p.name,
      a: p.arrivedAt,
      l: p.leftAt,
      e: p.emoji || '',
    })),
  };
  try {
    const json = JSON.stringify(data);
    const compressed = btoa(unescape(encodeURIComponent(json)));
    return compressed;
  } catch {
    return '';
  }
}

// Декодирование данных из URL hash
export function decodeBanyaData(hash) {
  if (!hash) return null;
  try {
    const json = decodeURIComponent(escape(atob(hash)));
    const data = JSON.parse(json);
    if (!data || !data.st || !data.et) return null;
    return {
      name: data.n || '',
      date: data.d || '',
      startTime: data.st,
      endTime: data.et,
      hourlyRate: data.hr || 0,
      broomCost: data.bc || 0,
      people: (data.p || []).map((p) => ({
        id: p.id,
        name: p.name,
        arrivedAt: p.a,
        leftAt: p.l,
        emoji: p.e || '',
      })),
    };
  } catch {
    return null;
  }
}
